import { TrustpilotTestimonial } from "./TrustpilotTestimonial";
import type { TrustpilotTestimonialProps } from "./TrustpilotTestimonial.d";

export { TrustpilotTestimonial, TrustpilotTestimonialProps };
